import React, {Component} from 'react'
import {browserHistory} from 'react-router'
import './Compte.scss'
import User from 'EurestoClass/User'
import Grid from '@material-ui/core/Grid'
import Avatar from 'Components/Avatar'

// import NotificationHistoriqueSimple from '../../../../components/Notification/NotificationHistoriqueSimple';
let styles = {
  bmBurgerButton: {
    position: 'relative',
    width: '40px',
    height: '40px',
    //right: '50px',
    //top: '10px',
    //padding: '0.5px 0.5px 0.5px 0.5px',
    color: 'white',
    zIndex: 100,
    fontSize: '25px'
  },
  bmBurgerBars: {
    background: '#2a6191'
  },
  bmCrossButton: {
    top: '0px',
    color: EurestoColor('EurestoError'),
    fontSize: 20,
    left: 2
  },
  bmMenu: {
    background: '#2a6191',
    padding: '1.2em 0 0 0',
    marginTop: '-15px',
    fontSize: '1.15em',
    marginLeft: 0
  },
  bmMorphShape: {
    fill: '#2a6191'
  },
  bmItemList: {
    color: '#b8b7ad',
    padding: 0.5
  },
  bmOverlay: {
    background: 'rgba(0, 0, 0, 0.3)'
  },
  bmMenuWrap: {
    width: '180px'
  },
}

let menuItelStyle = {
  color: '#ffffff',
  padding: 0.5
}

export default class CompteBurger extends Component {
  constructor (props) {
    super(props)
    this.state = {
      notification: props.notification
    }
  }

  leaveSite = () => {
    User.Disconnect.get()
  }

  onCLickCompte = () => {
    browserHistory.push({
      pathname: '/compte',
      state: {}
    })
  }

  render () {
    return (
      <Grid container style={{
        margin: 0,
        padding: 0,
        paddingRight: 5,
        paddingTop: User.User.get().media_lien && '0px' || 5
      }} spacing={0} justify={'center'}
            alignItems={'center'}>
        <Grid item style={{
          cursor: 'default',
          fontSize: '80%',
          paddingRight: 5
        }}>
          <Grid container style={{ margin: 0, padding: 0 }} spacing={0} justify={'space-around'} alignItems={'center'}
                direction={'column'}>
            <span style={{lineHeight: 1, fontSize: 12, fontWeight: 350, marginBottom: -5}}>{User.User.get().prenom}</span>
            <span onClick={() => this.leaveSite()} style={{
              fontSize: 10,
              //marginTop: '-10px !important',
              cursor: 'pointer',
              textDecoration: 'underline'
            }}>(Déconnexion)</span>
          </Grid>
        </Grid>
        <div style={{ padding: 5, margin: 0, cursor: !User.User.isConnectedAs() && 'pointer' || 'not-allowed', display: 'inline' }} onClick={() => !User.User.isConnectedAs() && this.onCLickCompte()}>
          {User.User.get().media_lien &&
          <Avatar src={User.User.get().media_lien} style={{ width: '30px', height: '30px' }}/>
          ||
          <i style={{ fontSize: 28 }} className={'ei-module_crm'}/>
          }
        </div>
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./app/App/Page/Compte/Component/Compte/Compte.js